import { Injectable } from '@angular/core';
import {
  Action,
  AngularFirestore,
  AngularFirestoreCollection,
  DocumentChangeAction,
  DocumentReference,
  DocumentSnapshot,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Partido } from '../models/partido';

@Injectable({
  providedIn: 'root'
})
export class PartidosService {
  private partidoCollection: AngularFirestoreCollection<Partido>;

  constructor(private db: AngularFirestore) {
    this.partidoCollection = this.db.collection<Partido>('partidos');
  }

  /**
   * GET ALL PARTIDOS
   */
  getAllPartidos(): Observable<DocumentChangeAction<Partido>[]> {

    return this.partidoCollection.snapshotChanges();
  }

  /**
   * GET PARTIDO BY ID
   * @param partidoId
   */
  getPartido(partidoId: string): Observable<Action<DocumentSnapshot<Partido>>> {
    return this.partidoCollection.doc<Partido>(partidoId).snapshotChanges();
  }

  /**
   * CREATE NEW PARTIDO
   * @param newPartido
   */
  createPartido(newPartido: Partido): Promise<DocumentReference> {
    return this.partidoCollection.add(newPartido);
  }

  /**
   * UPDATE SELECTED PARTIDO
   * @param data
   * @param docId
   */
  updatePartido(data: Partido, docId: string): Promise<void> {
    return this.partidoCollection.doc<Partido>(docId).update(data);
  }

  /**
   * DELETE PARTIDO
   * @param docId
   */
  deletePartido(docId: string): Promise<void> {
    return this.partidoCollection.doc<Partido>(docId).delete();
  }

  /**
 * GET ALL PARTIDOS por id usa el parametro idQuiniela
 */
  getAllPartidosByIdQuiniela(idQuiniela: any): Observable<DocumentChangeAction<any>[]> {
    var query = this.db.collection('partidos', (ref) =>
      ref.where('idQuiniela', '==', idQuiniela)
    );
    return query.snapshotChanges()
    //return this.partidoCollection.snapshotChanges();
  }

  /**
* DELETE ALL PARTIDOS DE UNA QUINIELA POR SU ID
*/
  deleteAllPartidosByIdQuiniela(idQuiniela: any): void {
    let query = this.db.collection('partidos', ref => ref.where('idQuiniela', '==', idQuiniela));
    query.get().toPromise().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        doc.ref.delete();
      });
    });
  }
}
